import {createLoginStripeLink, createConnectedAccount, getStripeAccountDetail, updateConnectedAccount} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import {openInNewTab, loader, message} from '@/libs/helper'
import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue'
import { isEmpty } from 'lodash'
import { mapGetters } from 'vuex'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'DonationPayout',
    components: {
        SettingsDropdown
    },
    computed: {
        ...mapGetters(['hasPermission'])
    },
    async mounted() {
        this.loading=true
        await this.fetchStripeAccountDetail()
        this.loading=false
    },
    data() {
        return {
            isPayout: false,
            payoutList: [],
            payoutRecord: {},
            currentPage: 1,
            searchValue: '',
            columns: ['name', 'month', 'donations', 'balance', 'status', 'settings'],
            tableSettings: {
                headings: { settings: '' },
                pagination: { show: false},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            loading:false,
            payoutListTemp:[],
            searchedpayoutList:[],
            permissions: permissions
        }
    },
    props: {
        accountStatus: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        accountStatus () {
            this.fetchStripeAccountDetail()
        }
    },
    methods: {
        /**
         * get login lik for stripe Account
         * @param {*} isTrue 
         */
        async getLoginStripeLink (isTrue) {
            try {
                loader(this, true)
                // body for api
                let body = {
                    entity_id: this.$route.params.id,
                    entity_type: this.$route.params.type.toUpperCase()
                }
                // api call
                let response = await createLoginStripeLink(body)
                // if account link to be visited
                if (isTrue && response.redirect_link && response.redirect_link !== '') openInNewTab(`${response.redirect_link}#account`)
                // if payout link to be visited
                else openInNewTab(response.redirect_link)
            } catch (error) {
                // error message
                message(this, constants.messageType.ERROR, error.message)
            }
            finally {
                loader(this, false)
            }
        },
        /**
         * apply donation and redirect user 
         * to stripe to add connected account
         */
        async createStripeConnectedAccount () {
            try {
                loader(this, true)
                // body for api
                let body = {
                    entity_id: this.$route.params.id,
                    entity_type: this.$route.params.type.toUpperCase()
                }
                // api call
                let response = await createConnectedAccount(body)
                // redirect user to stripe
                openInNewTab(response.redirect_link)
            } catch (error) {
                // error message
                message(this, constants.messageType.ERROR, error.message)
            }
            finally {
                loader(this, false)
            }
        },
        async querySearch (query , cb) {
            this.payoutListTemp=[...this.payoutList]
            const result=await this.payoutList.filter((item)=> item && item.display_name.toLowerCase().includes(query))
            this.searchedpayoutList=[...result]
            cb(result)
        },
        handleFilters () {
            this.payoutList=this.searchedpayoutList;
        },
        changePage () {},

        /**
         * table component handle command
         * @param {*} command 
         */
        handleCommand (command, data) {
            switch (command) {
                case 'CHANGE_NAME':
                    this.updateStripeAccount(data)
                break
                case 'PAY_OUT':
                    this.getLoginStripeLink()
                break
                case 'VIEW_ACCOUNT':
                    this.getLoginStripeLink(true)
                break
                case 'REMOVE':
                    
                break
                case 'UPDATE_ACCOUNT':
                    this.updateStripeAccount(data)
                break
            }
        },

        /**
         * to fetch the stripe account detail
         */
        async fetchStripeAccountDetail () {
            if(!this.hasPermission(permissions.getStripeAccountDetail)) return;
            // if (this.accountStatus && this.accountStatus.details_submitted) {
                // body for api
                let body = {
                    entity_id: this.$route.params.id,
                    entity_type: this.$route.params.type && this.$route.params.type.toUpperCase()
                }
                // api call
               await getStripeAccountDetail(body)
                .then(response => {
                    this.payoutList = [{...response.result, ...response.balance}]
                }).catch(() => {
                    // console.error(error)
                })
            // }    
        },

        /**
         * sum of pending ammount
         * @param {*} pending 
         */
        summationOfPendingAmount (pending) {
            let sum = 0
            if (!isEmpty(pending)) {
                pending.map(account => {
                    sum += account.amount
                })
            }
            return sum
        },

        /**
         * to update the stripe account and provide the redirection link
         */
        async updateStripeAccount () {
            try {
                // if (account && account.signal && account.signal !== 'GREEN') {
                    loader(this, true)
                    // body for api
                    let body = {
                        entity_id: this.$route.params.id,
                        entity_type: this.$route.params.type && this.$route.params.type.toUpperCase()
                    }
                    // api call
                    let response = await updateConnectedAccount(body)
                    // redirect user to stripe
                    openInNewTab(response.redirect_link)
                    loader(this, false)
                // }
            } catch (error) {
                loader(this, false)
                console.error(error)
            }
        }
    }
}